export { StrategyBasedAuthModule } from './auth.module';
export { AuthService } from "./auth.service";
export { LocalStrategy } from "./strategies/local/local-strategy";

